import {DivisionPickupStatus} from "@/enums/status";

export class DivisionPickupParams {
    page? = 1;
    limit? = 10;
    search?: string;
    fromDate?: number;
    toDate?: number;
    customerRowGuid?: string;
    status?: DivisionPickupStatus;
    statusString?: string;
    receiveEmployeeRowGuid?: undefined;
}

export class PickupLadingParams {
    page? = 1;
    limit? = 10;
}
